import * as Panels from '../../util/panels';
import React from 'react';
import {RunComparerConfig} from './common';
import * as Query from '../../util/queryts';
import {toRunsDataQuery} from '../../containers/RunsDataLoader';
import {useSampleAndQueryToTable} from '../Export';

const PANEL_TYPE = 'Run Comparer';

const runComparerTransformQuery = (
  query: Query.Query,
  config: RunComparerConfig
) => {
  const transformed = toRunsDataQuery(
    query,
    {selectionsAsFilters: true},
    {fullConfig: true, fullSummary: true}
  );
  return transformed;
};

const useTableData = (pageQuery: Query.Query, config: RunComparerConfig) => {
  const query = toRunsDataQuery(
    pageQuery,
    {selectionsAsFilters: true},
    {fullConfig: true, fullSummary: true}
  );

  return useSampleAndQueryToTable(query, pageQuery, config);
};

export const Spec: Panels.PanelSpec<typeof PANEL_TYPE, RunComparerConfig> = {
  type: PANEL_TYPE,
  Component: React.lazy(() => import('./Component')),
  transformQuery: runComparerTransformQuery,
  noEditMode: true,

  exportable: {
    csv: true,
    api: true,
  },

  useTableData,
  icon: 'panel-run-comparer',
};
